import React from "react";
import EmailSignup from "./components/EmailSignup";
import AudioDemo from "./components/AudioDemo";

export default function LandingPage() {

  return (
    <div>
      {/* Header */}
      <header className="header">
        <div className="logo" style={{ cursor: 'pointer' }} onClick={() => window.location.href = '/'}>
          <img alt="Light Reads logo" className="logo-img" src="/logo-quote.png" />
          <span className="logo-text">Light Reads</span>
        </div>
        <nav className="nav nav-light">
          <span style={{ cursor: 'pointer' }} onClick={() => window.location.href = '/about'}>For Authors and Publishers</span>
          <span style={{ cursor: 'pointer' }} onClick={() => window.location.href = '/about'}>About us</span>
        </nav>
      </header>

      {/* Hero Section with Email Signup */}
      <EmailSignup 
        title='Bring Your Story <span class="hero-title-accent">to Life.</span>'
        subtitle="Create immersive audiobooks and cinematic trailers from your manuscript in minutes."
        buttonText="Join Waitlist"
        successMessage="Thanks for joining! We'll notify you when Light Reads launches."
      />

      {/* Features Section */}
      <section className="features">
        <div>
          <h2 className="info-block-title">Upload your manuscript, and our AI studio does the rest.</h2>
          <p className="info-block-desc serif">
            Light Reads analyses your book to understand its setting, tone and characters. We suggest the best narrator style, generate a cast of AI voices for each character and even summarise your plot, so you start with a blueprint tailored to your story.
          </p>
        </div>
        <AudioDemo />
      </section>

      {/* Info Grid */}
      <section className="info-grid">
        <div className="info-block">
          <h3 className="info-block-title">Human-quality voices built for storytellers.</h3>
          <p className="info-block-desc serif">
            Our library of expressive voices covers a wide range of ages, accents and styles. Choose a single narrator for a consistent tone, or let each character speak in their own unique voice. Want to make changes? Edit pronunciation, pacing and emphasis with a click.
          </p>
        </div>
        <div className="info-block">
          <h3 className="info-block-title">Your creative control is paramount.</h3>
          <p className="info-block-desc serif">
            You decide how your book sounds. Easily swap voices, adjust the mood of a scene, or disable full-cast mode for straight narration. Our built-in pronunciation editor fixes tricky names and homonyms so the final product reflects your vision.
          </p>
        </div>
        <div className="info-block">
          <h3 className="info-block-title">Market your book like a pro.</h3>
          <p className="info-block-desc serif">
            Light Reads highlights key moments and turns them into a 30-second movie-trailer script, ready to feed into your favourite video generator. Promote your story across platforms with a cinematic teaser that matches the tone of your narration.
          </p>
        </div>
        <div className="info-block">
          <h3 className="info-block-title">Own your work. Distribute anywhere.</h3>
          <p className="info-block-desc serif">
            Export your audio or video files and publish on Audible, Spotify or your own website, no exclusivity and no hidden royalties. We never use your content to train voice models without permission.
          </p>
        </div>
      </section>

      {/* Built for authors and publishers */}
      <section className="built">
        <h3 className="built-title">Built for authors and publishers.</h3>
        <p className="built-desc serif">
          Skip the steep studio costs and confusing dashboards. Light Reads makes professional audio production accessible to every storyteller, whether you're publishing your first novel or scaling a backlist across multiple languages.
        </p>
      </section>

      {/* Footer */}
      <footer className="footer">
        Designed and built with love in Melbourne 📚 © 2025 Saturn Program Returns Pty Ltd
        <span className="footer-link">Privacy Policy</span>
        <span className="footer-link">Terms & Conditions</span>
      </footer>
    </div>
  );
} 